module.exports = __webpack_public_path__ + "img/社委中心.b94318a9.png";